import { inject, Injectable } from '@angular/core';
import { assert } from '@sama/js-core';
import { Point2D } from '../../team-apis/otterdam/answers/shape-typings';
import { PointCloudContentStore } from '../state/point-cloud-content-store';
import { KdTreeService } from './kd-tree.service';
import { getMouseVector } from './point-cloud-utils';
import { RayCastService } from './ray-cast.service';

@Injectable()
export class MouseCoordinateService {
  private kdTreeService = inject(KdTreeService);
  private rayCastService = inject(RayCastService);
  private store = inject(PointCloudContentStore);

  update(event: MouseEvent) {
    assert(event.target, 'event.target should be defined');
    const container = event.target as HTMLElement;
    const containerPoint: Point2D = getMouseVector(event, container).toArray();

    this.store('mouse').set({
      containerPoint,
    });
  }

  getGroundedMousePosition(
    containerPoint = this.store.state().mouse.containerPoint,
  ) {
    this.rayCastService.updateRay(containerPoint);
    const ray = this.rayCastService.getRay();
    return this.kdTreeService.getGroundIntersection(ray);
  }
}
